/**
 * Yemeni rial.
 */
export var YER = {
  code: 'YER',
  base: 10,
  exponent: 2
};